import React, { useEffect, useState, useContext } from "react";
import { MyContext } from "../../MyContext";
import { useNavigate } from "react-router-dom";

interface PlusProps {
  destination: string;
}

function Plus(props: PlusProps) {
  const navigate = useNavigate();

  const { onPage, setOnPage } = useContext(MyContext)!;

  return (
    <div
      className="add m-hide"
      onClick={() => {
        setOnPage(props.destination);
        navigate("/" + props.destination);
      }}
    >
      <img src="img/plus.svg" alt="Add new" />
    </div>
  );
}

export default Plus;
